<!--
<div *ngIf="!success" class="card-container">
    <mat-card class="card">
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <img src="/assets/img/logo_enap.png" alt="Enap" class="logo">
            <div class="card-title text-center">Enter and get your subscription</div>
            <div class="card-body">
                -->
                <!--Email-->
                <!--
                <div class="row">
                    <div class="col">
                        <mat-form-field class="w-100" style="margin-left: 10px !important;">
                        <input matInput placeholder="email" formControlName="email" [formControl]="emailFormControl" [errorStateMatcher]="matcher">
                        <mat-error *ngIf="emailFormControl.hasError('required')" >The email is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                -->
                <!--Password-->
                <!--
                <div class="row forgot-text-container">
                    <div class="col-12">
                        <mat-form-field class="w-100">
                        <input matInput placeholder="contraseña" formControlName="password" [formControl]="passwordFormControl" [errorStateMatcher]="matcher" [type]="passwordHide ? 'password' : 'text'">
                        <mat-icon class="element-hover" matSuffix (click)="passwordHide = !passwordHide" [ngClass]="{'visibility_off': passwordHide}">{{ passwordHide ? 'visibility_off' : 'visibility' }}</mat-icon>
                        <mat-error *ngIf="passwordFormControl.hasError('required')">The password is required</mat-error>
                        </mat-form-field>
                    </div>
                    -->
                    <!--<span class="remember mark forgot-text" (click)="forgot()">¿Olvidaste tu contraseña?</span>-->
                    <!--
                </div>
                
                

                <div class="row">
                        <div class="col">
                            <button mat-raised-button color="primary" class="action-button" [disabled]="loading ||loginForm.invalid" [ngClass]="{'active': !loading && !loginForm.invalid}">Login</button>
                        </div>
                    </div>
                </div>
        </form>
    </mat-card>
</div>
-->

 <header role="banner">
    <div class="header-content">
      <img src="/assets/img/addidassports.png" alt="Logo adidas Sports" class="logo">
      <h1>CRIAR SUA SENHA</h1>
      <p class="subtitle" *ngIf="!success">
        Olá, <strong>{{this.authService.id}}</strong> você está prestes a se juntar a nós e receber seus primeiros <span class="highlight">500 pontos</span> automaticamente
      </p>
      <p class="subtitle" *ngIf="success">
        Senha criada com sucesso! Bem-vindo ao clube, em breve você receberá sua <strong>500 pontos</strong> e um e-mail com o <strong>próximas etapas.</strong>
      </p>
    </div>
  </header>

  <main role="main" *ngIf="!success">
    <section class="form-section" aria-labelledby="form-title">
      <h2 id="form-title" class="sr-only">Formulário de registro</h2>
      
      
      <form class="registration-form" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
        <!--
        <div class="form-group">
          <label for="firstName">Nombre *</label>
          <input type="text" id="firstName" name="firstName" required 
                 placeholder="Ingresa tu nombre" aria-describedby="firstName-error">
          <span id="firstName-error" class="error-message" aria-live="polite"></span>
        </div>

        <div class="form-group">
          <label for="lastName">Apellido *</label>
          <input type="text" id="lastName" name="lastName" required 
                 placeholder="Ingresa tu apellido" aria-describedby="lastName-error">
          <span id="lastName-error" class="error-message" aria-live="polite"></span>
        </div>

        <div class="form-group">
          <label for="email">Correo electrónico *</label>
          <input formControlName="email" [formControl]="emailFormControl" type="email" id="email" name="email" required 
                 placeholder="ejemplo@correo.com" aria-describedby="email-error">
          <span id="email-error" class="error-message" aria-live="polite"></span>
        </div>
        -->
<!--
        <div class="form-group">
          <label for="phone">Teléfono</label>
          <input type="tel" id="phone" name="phone" 
                 placeholder="Opcional" aria-describedby="phone-error">
          <span id="phone-error" class="error-message" aria-live="polite"></span>
        </div>
        -->

        <div class="form-group">
          <label for="password">Senha *</label>
          <input formControlName="password" [formControl]="passwordFormControl" type="password" id="password" name="password" required 
                 placeholder="Mínimo de 8 caracteres" aria-describedby="password-error">
          <span id="password-error" class="error-message" aria-live="polite"></span>
          <!--
          <div class="password-requirements">
            <p>La contraseña debe contener:</p>
            <ul>
              <li id="length-check">Al menos 8 caracteres</li>
              <li id="uppercase-check">Una letra mayúscula</li>
              <li id="lowercase-check">Una letra minúscula</li>
              <li id="number-check">Un número</li>
            </ul>
          </div>
-->
        </div>
      

        <div class="form-group">
          <label for="confirmPassword">Confirmar senha *</label>
          <input type="password" id="confirmPassword" name="confirmPassword" required 
                 placeholder="Repita sua senha" aria-describedby="confirmPassword-error">
          <span id="confirmPassword-error" class="error-message" aria-live="polite"></span>
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input type="checkbox" id="newsletter" name="newsletter">
            <span class="checkmark"></span>
            Desejo receber ofertas e notícias por e-mail
          </label>
        </div>

        <button type="submit" class="submit-button" aria-label="Crear cuenta">
          CRIAR SENHA
        </button>
      </form>
    </section>
    
  </main>
  <div style="text-align: center;margin-top: 40px;">
    <img src="/assets/img/success.png" alt="Logo success adidas Sports" class="logo" *ngIf="success">
  </div>

  



